import module from './index'

let moduleName = 'module->' + module.info.name;
const routes = [
  {
    path: module.info.name,
    name: moduleName,
    component: () => import('./View.vue'),
    children: [
      {
        path: 'create',
        name: moduleName + '->create',
        component: () => import('./create/View'),
      },
      {
        path: 'list',
        name: moduleName + '->list',
        component: () => import('./list/View'),
        children: [
          {
            path: ':listPage',
            name: moduleName + '->list->page',
            component: () => import('./list/page/View'),
          }
        ]
      },
      {
        path: 'rates-panel',
        name: moduleName + '->rates-panel',
        component: () => import('./rates-panel/View'),
        children: [
          {
            path: ':tabName',
            name: moduleName + '->rates-panel->tab',
            component: () => import('./rates-panel/tabs/View.vue'),
          }
        ]
      },
      {
        path: ':entityTitle',
        name: moduleName + '->view',
        component: () => import('./view/View.vue'),
      }
    ]
  }
];

export default routes
